import {
  BadgeCheck, Droplet, Droplets, Flag, FlaskConical, Heart, Hexagon, Leaf,
  Shield, Sparkles, Wheat,
} from "lucide-react";

export const TIKTOK_SHOP_URL = "https://shop.tiktok.com/us/store/vivore/7495846249674082311";

export const AMAZON_URL = "https://www.amazon.com/dp/0jfDfy5t";

export const GALLERY = [
  { src: "/images/product/jar-front.webp", alt: "Vivoré Luxe Hydrating Cream jar, 8 oz", contain: true },
  { src: "/images/product/satin-portrait.webp", alt: "Open jar resting on pink satin with glass spheres", contain: false },
  { src: "/images/product/cream-smear.webp", alt: "The jar on a whipped cream smear", contain: true },
  { src: "/images/product/flatlay.webp", alt: "Flat lay with mango, apricot, honey and colloidal oats", contain: false },
  { src: "/images/product/texture.webp", alt: "Whipped cream texture close-up", contain: false },
  { src: "/images/product/peaches-honey.webp", alt: "Open jar with peaches and honeycomb in sunlight", contain: false },
  { src: "/images/product/with-box.webp", alt: "The jar beside its keepsake box", contain: false },
  { src: "/images/product/spheres.webp", alt: "Open jar styled with glass spheres", contain: false },
];

export const INGREDIENTS = [
  { icon: Droplets, name: "Shea Butter", desc: "Richly moisturizes, softens rough patches, and helps seal in moisture." },
  { icon: Sparkles, name: "Hydrolyzed Collagen", desc: "Helps bind moisture, leaving skin feeling smoother, softer, and more supple." },
  { icon: Droplet, name: "Squalane, Glycerin + Hyaluronic Acid", desc: "Help replenish and retain moisture for hydrated, plump-looking skin." },
  { icon: Shield, name: "Ceramides, Cholesterol + Phytosphingosine", desc: "Work together to support the skin’s natural moisture barrier." },
  { icon: Wheat, name: "Colloidal Oatmeal + Panthenol (Vitamin B5)", desc: "Help soothe dry skin and ease that tight, uncomfortable feeling." },
  { icon: Hexagon, name: "Manuka Honey", desc: "Helps attract and retain moisture while conditioning the skin." },
  { icon: Heart, name: "Peptides", desc: "Support smoother, firmer-looking skin." },
  { icon: Leaf, name: "Vitamin E", desc: "Provides antioxidant support and helps condition the skin." },
];

export const FULL_INGREDIENTS =
  "Water, Squalane, Shea Butter, Glycerin, Cyclopentasiloxane, Manuka Honey, Cetearyl Alcohol, Dimethicone, C12-15 Alkyl Benzoate, Butylene Glycol, Colloidal Oatmeal, Tocopherol, Glyceryl Stearate, Panthenol, PEG-100 Stearate, Hydrolyzed Collagen, Sodium Hyaluronate, Palmitoyl Tetrapeptide-7, Palmitoyl Tripeptide-1, Ceramide NP, Ceramide AP, Ceramide EOP, Caprylic/Capric Triglyceride, Xanthan Gum, Citric Acid, Sodium Lauroyl Lactylate, Polysorbate 20, Carbomer, Grapefruit Peel Extract, Apricot Fruit Extract, Sweet Orange Peel Oil, Phytosphingosine, Cholesterol, Lime Peel Extract, Lavender Herb Extract.";

export const QUALITY = [
  { icon: Flag, label: "Made in the USA" },
  { icon: FlaskConical, label: "Third-Party Tested" },
  { icon: BadgeCheck, label: "GMP-Certified Facility" },
];

export const REVIEWS = [
  { name: "Emma Collins", text: "Feels so soft and smooth. I love it." },
  { name: "Sophia Bennett", text: "Light, smooth, and really pleasant to use." },
];

export const FAQS = [
  {
    q: "How do I use it?",
    a: "Apply to your body, ideally after showering on slightly damp skin, and massage gently until absorbed. Use daily for soft, smooth, comfortable skin.",
  },
  {
    q: "What does it smell like?",
    a: "It carries a light, pleasant scent of mango, peach, and apricot — with no synthetic fragrance added.",
  },
  {
    q: "Is it for my face or my body?",
    a: "It is designed as a rich body moisturizer — perfect for dry arms, legs, elbows, knees, and anywhere skin feels tight or rough.",
  },
  {
    q: "Do you offer free shipping?",
    a: "Yes — free standard shipping is included on every US order. Orders are picked, packed, and shipped quickly by our fulfillment partner, Omnicore 3PL.",
  },
  {
    q: "What is your returns & refunds policy?",
    a: "If you are not delighted, returns are accepted within 30 days for a refund or replacement. Refunds are usually issued within 24 hours once your return is processed.",
  },
  {
    q: "Where else can I buy it?",
    a: "Vivoré is also available on Amazon and TikTok Shop — the official listings are linked above.",
  },
];
